"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultError = exports.ListingState = exports.SortKey = exports.OfferStatus = void 0;
var OfferStatus;
(function (OfferStatus) {
    OfferStatus["bought"] = "Bought";
    OfferStatus["uninitialized"] = "Uninitialized";
    OfferStatus["denied"] = "Denied";
    OfferStatus["cancelled"] = "Cancelled";
    OfferStatus["created"] = "Created";
})(OfferStatus = exports.OfferStatus || (exports.OfferStatus = {}));
var SortKey;
(function (SortKey) {
    SortKey["lastListing"] = "last_listing";
    SortKey["all"] = "all";
    SortKey["lastOffer"] = "last_offer";
    SortKey["lastSale"] = "last_sale";
    SortKey["listingPrice"] = "listing_price";
    SortKey["offerPrice"] = "offer_price";
    SortKey["salePrice"] = "sale_price";
})(SortKey = exports.SortKey || (exports.SortKey = {}));
var ListingState;
(function (ListingState) {
    ListingState["selling"] = "Selling";
    ListingState["uninitialized"] = "Uninitialized";
    ListingState["created"] = "Created";
})(ListingState = exports.ListingState || (exports.ListingState = {}));
// export enum TraitTypes {
//   smallgem = 'smallgem',
//   biggem = 'biggem',
//   base = 'base',
//   rim = 'rim'
// }
// export enum SmallGemValues {
//   pearl = 'Pearl',
//   opal = 'Opal',
//   emerals = 'Emerald',
//   amber = 'Amber',
//   moonstone = 'Moonstone',
//   amethyst = 'Amethyst',
//   ruby = 'Ruby',
//   diamond = 'Diamond',
//   citrine = 'Citrine',
//   sapphire = 'Sapphire'
// }
// export enum BigGemValues {
//   greenOrb = 'GreenOrb',
//   blueOrb = 'BlueOrb',
//   molecule = 'Molecule',
//   electricity = 'Electricity',
//   sun = 'Sun',
//   crystal = 'Crystal',
//   redOrb = 'RedOrb',
//   psychedelic = 'Psychedelic',
//   flame = 'Flame',
//   galaxy = 'Galaxy'
// }
// export enum BaseValues {
//   silver = 'Silver',
//   gold = 'Gold',
//   iridiscent = 'Iridescent',
//   psychedelic = 'Psychedelic',
//   circuit = 'Circuit',
//   crystal = 'Crystal',
//   ice = 'Ice',
//   bronze = 'Bronze',
//   lava = 'Lava',
//   galaxy = 'Galaxy'
// }
// export enum RimValues {
//   engraved = 'Engraved',
//   royal = 'Royal',
//   oliveBranch = 'OliveBranch',
//   wood = 'Wood',
//   glass = 'Glass',
//   velvet = 'Velvet',
//   blackMarble = 'BlackMarble',
//   candyCane = 'CandyCane',
//   diamond = 'Diamond',
//   rose = 'Rose'
// }
// export interface NFTTraits {
//   smallgem?: SmallGemValues;
//   biggem?: BigGemValues;
//   base?: BaseValues;
//   rim?: RimValues;
// }
// export interface NFTTraitFilters {
//   smallgem?: SmallGemValues[];
//   biggem?: BigGemValues[];
//   base?: BaseValues[];
//   rim?: RimValues[];
// }
// Errors
var ResultError;
(function (ResultError) {
    ResultError["IC"] = "IC";
    ResultError["ICNS"] = "ICNS";
    ResultError["InvalidCollection"] = "InvalidCollection";
    ResultError["DIP20"] = "DIP20";
    ResultError["InsufficientFungibleBalance"] = "InsufficientFungibleBalance";
    ResultError["DIP721"] = "DIP721";
    ResultError["NotFound"] = "NotFound";
    ResultError["InvalidListing"] = "InvalidListing";
    ResultError["Unauthorized"] = "Unauthorized";
    ResultError["InsufficientFungibleAllowance"] = "InsufficientFungibleAllowance";
    ResultError["InvalidOffer"] = "InvalidOffer";
    ResultError["InvalidOwner"] = "InvalidOwner";
    ResultError["Other"] = "Other";
    ResultError["InvalidOperator"] = "InvalidOperator";
})(ResultError = exports.ResultError || (exports.ResultError = {}));
